<template>
  <div class="Feedback">
    <v-snackbar
        :value=message
        :timeout=timeout
      >
        {{ message }}
      </v-snackbar>
  </div>
</template>
<script>
  import {mapActions, mapGetters } from 'vuex';
  export default {
    watch: {
      message(){
        setTimeout(() => {
          if(this.message !== null){
            this.dismissMessage();  
          }
        }, this.timeout);
      },
    },
    props: {
        timeout: {
            type: Number,
            required: true
        }
    },
    computed: {
      ...mapGetters({
      message: 'getReturnMessage',
      }), 
    },
    
    methods: {
        ...mapActions(['dismissMessage']),
        dismissHandler(){
          this.dismiss
        }
    },

    
  };
</script>